import { useRef } from "react";
import { FaEye } from "react-icons/fa";
const Image = ({url, imageClassName="imgGallery", divClassName="imageGallery ", ref, onClick, id, imageId, text}) => {
    const imageShow = useRef();
    const imageShowHandler = (url, imageId, text) => {
        if(document.getElementById("containerImageShow").style.visibility!=="visibility"){

            
            document.getElementById("idImageSelected").value = imageId;
            document.getElementById("discriptionImage").innerHTML = text;
            let image = document.getElementById("imageShow");
            let containerImageShow = document.getElementById("containerImageShow");
            image.src = url;    
            containerImageShow.style.opacity = 1;
            containerImageShow.style.visibility = "visible";
            // console.log(image);
        }
    }
    const closeImageShowHandler_2 = (event=null) => {
        let containerImageShow = document.getElementById("containerImageShow");
        containerImageShow.style.opacity = 1;
        containerImageShow.style.visibility = "visibility";
        // if(event.currentTarget){
            // alert("yess");   
        // }
        return false;

    }



    return (
            <>
                <div className={divClassName} onClick={() => imageShowHandler(url, imageId, text)}>
                    <img src={url} ref={imageShow} id={id}  className={imageClassName} />
                    
                    <div className="coverImage">
                        {/* <FaEye style={{fontSize: "30px"}}/> */}
                        {text}
                    </div>
                </div>

            </>
    )
}


export default Image;